import styled from 'styled-components'

export const DadosReciboAceite = styled.div`

`

DadosReciboAceite.PdfPreview = styled.div`
    .preview-content {
        max-height: 750px;
        overflow: auto;
    }

    .preview-wrapper {
        background: #aaaaaa;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border-radius: 8px;
    }

    .preview-bar {
        align-items: center;
        background-color: #323639;
        color: white;
        display: flex;
        height: var(--viewer-pdf-toolbar-height);
        padding: 16px 16px;
        width: calc(100% - 32px);
    }

    .preview-icons {
        display: none;
    }
    
    .preview-bar {
        justify-content: space-between;
    }

    .preview-bar-left {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 12px;
    }

    button.preview-button {
        padding: 0;
        min-width: 0;
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        border: 0;
        cursor: pointer;
        transition: all ease .35s;
        color: var(--white);
        background: transparent;
    }

    button.preview-button[disabled] {
        cursor: auto;
        color: #838383;
    }

    button.preview-button:hover {
        transition: all ease .35s;
        background: #5b5b5b;
    }
`